import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  InputProps,
  OutlinedInput,
} from '@mui/material';
import CloseIcon from './icons/CloseIcon';

interface Props extends InputProps {
  label?: string;
  handleClear?: () => void;
}

const TextField = (props: Props) => {
  const { label, handleClear, sx, ...otherProps } = props;
  return (
    <FormControl variant="standard" size="medium" sx={sx}>
      <InputLabel htmlFor="textfield">{label}</InputLabel>
      <OutlinedInput
        size="small"
        id={`textfield-${label}`}
        endAdornment={
          handleClear && (
            <InputAdornment position="end">
              <IconButton onClick={handleClear}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          )
        }
        {...otherProps}
      />
    </FormControl>
  );
};

export default TextField;
